import { axios } from "../config";

export const fetchPromotionLevels = () => {
  return axios.get("api/v1/levels/level-info");
};

export const promoteStudents = (data) => {
  return axios.post("api/v1/student-promotion", data);
};

export const fetchExamTypes = () => {
  return axios.get("api/v1/exams/all-exam-types");
};

export const fetchInstituteExams = (params) => {
  return axios.get("api/v1/exams/by-exam-type", { params });
};

export const fetchInstituteSubjects = () => {
  return axios.get("api/v1/subjects/subject-avilable-for-institution");
};

export const getPromotionStatus = (params) => {
  return axios.get("api/v1/student-promotion/jobs", { params });
};